/**
 * @fileoverview Action Member Carousel Controller Module.
 * Manages the initialization and configuration of the Glide.js carousel specifically for the action member section.
 */

import Glide from '@glidejs/glide'
import "@glidejs/glide/src/assets/sass/glide.core.scss";
import "@glidejs/glide/src/assets/sass/glide.theme.scss";
import { elementExists } from "../Utils";

const ActionMemberCarouselController = {
    actionsCarouselSelector: '.action-carousel-container',
    membersCarouselSelector: '.member-carousel-container',

    /**
     * Initializes the action member carousel if the container element exists.
     * This method checks for the presence of the carousel container and then initializes the Glide.js carousel.
     */
    init() {
        if (elementExists(this.actionsCarouselSelector)) {
            this.startActionsGlide();
        }
        if (elementExists(this.membersCarouselSelector)) {
            this.startMembersGlide();
        }
    },

    /**
     * Starts the Glide.js carousel with specific configuration options.
     * This method configures the carousel to be of type 'carousel', sets the number of visible slides per view,
     * and defines breakpoints for responsive behavior.
     */
    startActionsGlide() {
        new Glide(this.actionsCarouselSelector, {
            type: 'carousel',
            perView: 3,
            gap: 20,
            breakpoints: {
                1024: {
                    perView: 2
                },
                768: {
                    perView: 1
                }
            }
        }).mount();
    },

    /**
     * Starts the Glide.js carousel with specific configuration options.
     * This method configures the carousel to be of type 'carousel', sets the number of visible slides per view,
     * and defines breakpoints for responsive behavior.
     */
    startMembersGlide() {
        new Glide(this.membersCarouselSelector, {
            type: 'carousel',
            perView: 3,
            gap: 20,
            breakpoints: {
                1024: {
                    perView: 2
                },
                768: {
                    perView: 1
                }
            }
        }).mount();
    }
}

export default ActionMemberCarouselController;